<template>
  <div class="seconDkill_box" :class="{ paddingTop: !isApp }">
    <common-title titleName="秒杀活动进行中" :goHome="true" :zIndex="1000"></common-title>
    <!-- banner -->
    <div class="dkill_banner">
      <img src="@/assets/img/activity/seconDkill/seconDkill_boxBanner.png" alt="" />
    </div>

    <!-- tabs -->
    <div class="robDate">
      <ul class="dateList">
        <li>
          <img class="Looting" src="@/assets/img/activity/seconDkill/nowLootingNew.png" alt="" />
        </li>
        <li
          v-for="(item, index) in seckillList"
          :class="{ styBg: index == showSeconDkill, tabOverClass: item.status == 1 }"
          :key="index"
          @click="seconDkill_tab(index, item.status)"
        >
          <div>{{ item.time }}</div>
          <template v-for="(item1, index1) in tabTypeList">
            <p v-if="item1.tabType === item.status" :key="index1">
              <span>{{ item1.name }}</span>
            </p>
          </template>
        </li>
      </ul>
    </div>

    <!-- tabItems 秒杀课列表 -->
    <div class="dkillListBox">
      <ul class="dkillList">
        <li
          class="dkillItem"
          v-for="(sonItem, index) in list.productBaseListWebRespVOS"
          :key="index"
          @click="goDetails(sonItem.productId)"
        >
          <h2 class="dkillTitle">
            <i v-if="sonItem.name.substr(0, 1) == '【'" class="title-special-processing" />{{
              sonItem.name
            }}
          </h2>
          <div class="TimeHours">
            <p class="Time" v-if="sonItem.startTime">
              开课时间<span>{{ getTime(sonItem.startTime) }}</span>
            </p>
            <p class="hourse" v-if="sonItem.classPeriod">
              课时<span>{{ sonItem.classPeriod }}</span>
            </p>
          </div>
          <dl class="activityTag">
            <dd v-if="sonItem.productDiscountRespVO.isUnionDiscount">联报优惠</dd>
            <dd v-if="sonItem.productDiscountRespVO.isSingleDiscount">满减活动</dd>
          </dl>

          <ol class="teacherList">
            <li
              v-for="(teacherItem, teaind) in sonItem.teacherRespVOS
                ? sonItem.teacherRespVOS.slice(0, 3)
                : ''"
              :key="teaind"
            >
              <img :src="teacherItem.teacherHead || defineHeadImg" alt="" />
              <p>{{ teacherItem.name }}</p>
            </li>

            <div class="progress" v-if="sonItem.itCanBug">
              <p class="progressText">
                马上抢<img src="@/assets/img/activity/seconDkill/goIcon.png" alt="" />
              </p>
              <!-- <div class="progressLine">
                <div><p :style="{ width: parseInt(sonItem.progress)>0?sonItem.progress:'0%' }"></p></div>
                {{ parseInt(sonItem.progress)>0?sonItem.progress:"0%" }}
              </div> -->
            </div>

            <div class="progress1" v-else>
              <p class="progressText">
                <span>{{ getTimeHms(sonItem.productDiscountRespVO.promotionBeginTime) }}</span>
                <span>开抢</span>
              </p>
            </div>

            <div class="priceBox">
              <del>¥{{ sonItem.sellPrice }}</del>
              <p>
                <i>¥</i><span>{{ sonItem.productDiscountRespVO.discountMinPrice }}</span>
              </p>
            </div>
          </ol>

          <div class="dkillCardBto">
            <div
              v-if="sonItem.isExistsAudition"
              class="audition"
              @click.stop="auditionClick(sonItem.productId, sonItem.auditionVideoId,sonItem.sonItem)"
            >
              <img src="@/assets/img/activity/seconDkill/videoIcon.png" />支持试听
            </div>
            <!-- 距结束-->
            <p class="endTime" v-if="sonItem.dayTime">
              <span>{{ sonItem.timeStatus ? '距结束：' : '距开始：' }}</span>
              <span v-if="sonItem.dayTime.day">
                <span class="timeNumber">{{ sonItem.dayTime.day }}</span>
                <span>天</span>
              </span>
              <span v-if="sonItem.dayTime.hour">
                <span class="timeNumber">{{ sonItem.dayTime.hour }}</span>
                <span>时</span>
              </span>
              <span v-if="sonItem.dayTime.minute">
                <span class="timeNumber">{{ sonItem.dayTime.minute }}</span>
                <span>分</span>
              </span>
              <span v-if="sonItem.dayTime.second">
                <span class="timeNumber">{{ sonItem.dayTime.second }}</span>
                <span>秒</span>
              </span>
            </p>
          </div>
        </li>
      </ul>

      <!-- 占位图 -->
      <div class="placeholderBox" v-if="placeholderBoxShow">
        <p><img src="@/assets/img/activity/seconDkill/placeholderIcon.png" alt="" /></p>
        <p><span>别急~ 一大波秒杀活动即将来袭</span></p>
      </div>
    </div>
    <dialogComponent ref="dialogComponent" dialogType="downloadApp" />
  </div>
</template>

<script>
import { reqServiceTime } from '@/api/common/index';
import { reqSeconDkill } from '@/api/activity';
// import InfiniteLoading from 'vue-infinite-loading';
import { dateTime, replaceHyphens } from '@/utils/tools';
import dialogComponent from '@/components/dialogComponent/dialogComponent.vue';

export default {
  name: '',
  data() {
    return {
      nowTime: new Date().getTime(), // 当前时间戳
      dkillTitle: '秒杀活动进行中',
      seckillList: '', // 全部数据
      placeholderBoxShow: false, // 是否显示缺省图
      list: [], // 单个tab的数据
      showSeconDkill: 0, // 当前tab的index
      // tab name&status 关系：1-已结束 2-抢购中 3-即将开始 4-敬请期待
      tabTypeList: [
        { tabType: 1, name: '秒杀结束' },
        { tabType: 2, name: '抢购中' },
        { tabType: 3, name: '即将开始' },
        { tabType: 4, name: '敬请期待' },
      ],
      isInitialized: true,
      temp: null, // 定时器
      defineHeadImg: require('@/assets/img/activity/seconDkill/defaultAvatar.png'),
      isApp: this.$root.$data.isApp,
    };
  },

  components: {
    // InfiniteLoading,
    dialogComponent,
  },
  created() {},
  mounted() {
    this.SERVICETIME();
  },
  beforeRouteEnter(to, from, next) {
    document.querySelector('.app').setAttribute('style', 'background-color:#fff'); // 添加背景色
    next();
  },

  beforeRouteLeave(to, from, next) {
    document.querySelector('.app').setAttribute('style', ''); // 去除背景色
    next();
  },
  methods: {
    // 服务器时间
    async SERVICETIME() {
      const serviceTime = await reqServiceTime();
      if (serviceTime.code === 0) {
        this.nowTime = serviceTime.data;
        const yearmd = serviceTime.data.split(' ')[0];
        this.timeSlot(yearmd);
      }
    },
    // 静态时间段
    async timeSlot(yearmd) {
      const data = [
        {
          startTime: `${yearmd} 14:00:00`,
          endTime: `${yearmd} 18:59:59`,
        },
        {
          startTime: `${yearmd} 19:00:00`,
          endTime: `${yearmd} 19:59:59`,
        },
        {
          startTime: `${yearmd} 20:00:00`,
          endTime: `${yearmd} 20:59:59`,
        },
        {
          startTime: `${yearmd} 21:00:00`,
          endTime: `${yearmd} 21:59:59`,
        },
        {
          startTime: `${yearmd} 22:00:00`,
          endTime: `${yearmd} 23:59:59`,
        },
      ];
      // 全部秒杀列表
      const res = await reqSeconDkill(data, this.isApp ? 2 : 4, 1);
      if (res.code === 0) {
        const resData = res.data;
        let HotIndex;
        const nowTime = new Date(replaceHyphens(this.nowTime)).getTime();
        // const nowTime = new Date().getTime();//本地时间戳
        const seckillList = resData.map((item, ind) => {
          if (nowTime > new Date(replaceHyphens(item.endTime)).getTime()) {
            Object.assign(item, { status: 1 });
          } else if (
            new Date(replaceHyphens(item.startTime)).getTime() <= nowTime
            && nowTime <= new Date(replaceHyphens(item.endTime)).getTime()
          ) {
            Object.assign(item, { status: 2 });
            HotIndex = ind;
          } else if (!item?.productBaseListWebRespVOS?.length > 0) {
            Object.assign(item, { status: 4 });
          } else if (nowTime < new Date(replaceHyphens(data[ind].startTime)).getTime()) {
            Object.assign(item, { status: 3 });
          }

          switch (ind) {
            case 0:
              Object.assign(item, { time: '14:00' });
              break;
            case 1:
              Object.assign(item, { time: '19:00' });
              break;
            case 2:
              Object.assign(item, { time: '20:00' });
              break;
            case 3:
              Object.assign(item, { time: '21:00' });
              break;
            case 4:
              Object.assign(item, { time: '22:00' });
              break;
            default:
              break;
          }

          return item;
        });
        this.seckillList = seckillList;
        this.showList(HotIndex);
      }
    },
    // 展示的秒杀列表
    showList(index) {
      // if (!(index !== undefined)) {
      //   this.showSeconDkill = -1;
      //   return;
      // }
      const ind = index || 0;
      this.showSeconDkill = ind;
      this.list = this.seckillList[ind];
      if (this.list?.productBaseListWebRespVOS?.length > 0) {
        this.timerProcessor(); // 立刻计算倒计时
        this.timer(); // 每1s 计算倒计时
        this.placeholderBoxShow = false;
      } else {
        this.placeholderBoxShow = true;
      }
    },

    countDownFun(time) {
      /*eslint-disable*/
      time--; // 时间一秒秒的减
      /*eslint-disable*/
      const nowTime = new Date().getTime(); // 现在时间
      if (nowTime <= time) {
        // 获取时间差
        const timediff = Math.round((time - nowTime) / 1000); // 获取还剩多少天
        // eslint-disable-next-line radix
        let day = parseInt(timediff / 3600 / 24); // 获取还剩多少小时
        // eslint-disable-next-line radix
        const hour = parseInt((timediff / 3600) % 24); // 获取还剩多少分钟
        // eslint-disable-next-line radix
        const minute = parseInt((timediff / 60) % 60); // 获取还剩多少秒
        const second = timediff % 60;
        day = day > 0 ? day : '';
        return {
          day,
          hour: hour.toString().padStart(2, '0'),
          minute: minute.toString().padStart(2, '0'),
          second: second.toString().padStart(2, '0'),
        };
      }
      return {
        day: '',
        hour: '00',
        minute: '00',
        second: '00',
      };
    },

    timer() {
      // 页面多个定时器 //主要逻辑都在这页面更新
      this.temp = setInterval(() => {
        this.timerProcessor();
      }, 1000);
    },

    timerProcessor() {
      const that = this;
      that.list.productBaseListWebRespVOS.forEach((item) => {
        if (item && item.productDiscountRespVO.promotionEndTime) {
          const nowTime = new Date().getTime();
          const { promotionBeginTime, promotionEndTime } = item.productDiscountRespVO;

          const itCanBay =
            nowTime >= new Date(replaceHyphens(promotionBeginTime)).getTime() &&
            nowTime <= new Date(replaceHyphens(promotionEndTime)).getTime();
          that.$set(item, 'itCanBug', itCanBay); // 是否可购买
          if (nowTime < new Date(replaceHyphens(promotionBeginTime)).getTime()) {
            that.$set(item, 'timeStatus', 0); // 结束时间
            that.$set(
              item,
              'dayTime',
              that.countDownFun(new Date(replaceHyphens(promotionBeginTime)).getTime()),
            ); // 结束时间
          } else {
            that.$set(item, 'timeStatus', 1); // 开始时间
            that.$set(
              item,
              'dayTime',
              that.countDownFun(new Date(replaceHyphens(promotionEndTime)).getTime()),
            ); // 开始时间
          }
        }
      });
    },

    // 清除定时器
    clearTimer() {
      if (this.temp) clearInterval(this.temp);
      this.temp = null;
    },

    // 秒杀选项卡
    seconDkill_tab(index, status) {
      if (status === 1) {
        return false;
      }
      if (index !== this.showSeconDkill) {
        // 有数据 且 非已结束
        this.showSeconDkill = index;
        this.clearTimer();
        this.showList(index);
      }
      return true;
    },

    // 获取年月日
    getTime(time) {
      // 获取时间
      const dateFormat = dateTime(new Date(replaceHyphens(time)).getTime());
      return `${dateFormat.year}.${dateFormat.month}.${dateFormat.day}`;
    },

    // 时分
    getTimeHms(time) {
      const dateFormat = dateTime(new Date(replaceHyphens(time)).getTime());
      return `${dateFormat.h}:${dateFormat.m}`;
    },
    // 子组件组件打开弹窗 试听
    openAppDialog() {
      this.$refs.dialogComponent.show = true;
    },
    // 试听视频跳转

    auditionClick(productId, auditionVideoId,name) {
      if (this.isApp) {
        this.$sendToApp(
          'goTrialCoursePage',
          { courseId: productId, productCurriculumId: auditionVideoId,courseName: name, },
          false,
        );
      } else {
        this.openAppDialog();
      }
    },

    goDetails(productId) {
      if (this.isApp) {
        // app内嵌
        this.$sendToApp('goCourseDetail', Number(productId), false);
        return;
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
          },
        });
      }
    },
  },

  beforeDestroy() {
    this.clearTimer();
  },
};
</script>
<style lang="scss" scoped>
.seconDkill_box {
  font-family: PingFangSC-Regular, sans-serif;
  background: #fefeff !important;
  div,
  p,
  span,
  li,
  h2 {
    font-family: PingFangSC-Regular, sans-serif;
  }
}
.paddingTop {
  padding-top: 100px;
}

.dkill_banner {
  height: 272px;
  margin: 14px 36px 0;

  img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
}

// 正在疯抢
.robDate {
  position: relative;
  display: flex;
  align-items: center;
  height: 130px;
  margin: 18px 36px 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 9px 0 rgba(245, 251, 253, 1);
}

.Looting {
  width: 71px;
}

.robBg {
  position: relative;
  height: 80px;
  margin-left: 11px;
  padding-left: 194px;
  background: linear-gradient(180deg, #f57230 0%, #ff661b 55%, #f57231 100%);
  border: 4px solid #ffe1b3;
  border-radius: 16px;
  box-shadow: 0 4px 7px 0 rgba(251, 105, 33, 0.42);
}

.noOngoing {
  display: flex;
  justify-content: center;
  padding-left: 0;
}

.robBg_line {
  position: absolute;
  top: 50%;
  width: 462px;
  height: 10px;
  margin-top: -4px;
  overflow: hidden;
  background: #8e2c01;
  border: 2px solid #d95616;
  border-radius: 6px;

  p {
    width: 337px;
    height: 100%;
    background: #ffe1b3;
    border-radius: 6px;
  }
}

.robBg_lineSty {
  p {
    width: 50%;
  }
}

.dateList {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  margin-top: 10px;

  li {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    div {
      color: #333;
      font-weight: 700;
      font-size: 28px;
      line-height: 29px;
      white-space: nowrap;
    }

    p {
      margin-top: 9px;
      color: #333;
      font-size: 22px;
      line-height: 32px;
      white-space: nowrap;

      span {
        padding: 0 12px;
      }
    }
  }

  .robBox {
    div {
      img {
        width: 18px;
        height: 20px;
      }
    }
  }

  /* 被点击状态 */

  .styBg {
    > div {
      color: #ff7a1b;
    }

    > p {
      box-sizing: border-box;
      background: #ff7a1b;
      border-radius: 16px;

      span {
        color: #fff;
      }
    }
  }

  //已结束tab
  .tabOverClass {
    div {
      color: #a5a5a5;
    }

    p {
      > span {
        color: #a5a5a5;
      }
    }
  }
}

.dateListSty {
  li {
    margin-left: calc(50% - 50px);
  }
}

// 课程列表
.dkillListBox {
  padding-bottom: 100px;
  font-family: PingFangSC-Regular, sans-serif;

  /* 占位图 */
  .placeholderBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 130px;
    > p:nth-child(1) {
      img {
        width: 369px;
      }
    }

    > p:nth-child(2) {
      > span {
        color: #a5a5a5;
        font-size: 22px;
        line-height: 31px;
      }
    }
  }
}

.dkillList {
  margin: 25px 35px 0;

  & > li {
    margin-bottom: 18px;
    padding: 20px 31px 20px 25px;
    background: #fff;
    border-radius: 7px;
    box-shadow: 0 2px 9px 0 #eee;
  }
}

.dkillTitle {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  color: #333;
  font-weight: bold;
  font-size: 33px;
  line-height: 45px;
  letter-spacing: 0.5px;
}

.activityTag {
  margin: 11px 0;
  font-size: 0;

  dd {
    display: inline-block;
    box-sizing: border-box;
    height: 36px;
    margin-right: 5px;
    padding: 0 12px;
    color: #fe5e18;
    font-size: 18px;
    line-height: 32px;
    border: 2px solid #fe5e18;
    border-radius: 7px;
  }
}

.TimeHours {
  display: flex;
  align-items: center;
  margin-top: 10px;
  line-height: 30px;

  p {
    margin-right: 14px;
    color: #a5a5a5;
    font-size: 25px;
  }

  span {
    margin-left: 12px;
    color: #a5a5a5;
    font-size: 25px;
  }
}

.teacherList {
  position: relative;
  // overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin-top: 46px;

  & > li {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 84px;
    margin-right: 12px;
    img {
      width: 63px;
      height: 63px;
      border-radius: 50%;
      // background: red;
    }

    p {
      /* max-width: 1px; */
      width: 100%;
      margin-top: 10px;
      overflow: hidden;
      color: #333;
      font-size: 18px;
      line-height: 28px;
      white-space: nowrap;
      text-align: center;
      text-overflow: ellipsis;
    }
  }

  .priceBox {
    position: absolute;
    right: 160px;
    bottom: 3px;
    display: flex;
    align-items: baseline;

    del {
      margin-right: 8px;
      color: #a5a5a5;
      font-size: 22px;
      line-height: 32px;
    }

    & > p {
      margin-top: 6px;
      color: #ff691e;
      font-size: 26px;
      line-height: 36px;
      text-align: center;

      i {
        margin: 0 4px;
        color: #ff691e;
        font-style: inherit;
      }

      span {
        color: #ff691e;
        font-size: 38px;
      }
    }
  }

  /* 进行中 */

  .progress {
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 139px;
    height: 74px;
    padding: 6px 4px 6px;
    background: linear-gradient(226deg, #ff9735 0%, #fe5e18 100%);
    border-radius: 7px;

    .progressText {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 25px;
      line-height: 36px;

      img {
        display: block;
        width: 10px;
        height: 18px;
        margin-top: 2px;
        margin-left: 9px;
      }
    }
  }

  /* 未开始 */
  .progress1 {
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 139px;
    height: 74px;
    padding: 6px 4px 6px;
    background: #d5d5d5;
    border-radius: 7px;

    .progressText {
      display: flex;
      // flex-direction: column;
      align-items: center;
      justify-content: center;
      line-height: 32px;

      span {
        color: #fff;
        font-size: 25px;
      }
    }
  }
}

.progressLine {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
  color: #fff;
  font-size: 18px;

  & > div {
    width: 67px;
    height: 7px;
    margin-right: 4px;
    overflow: hidden;
    background: rgba(238, 238, 238, 0.6);
    border-radius: 6px;

    p {
      // width: 88%;
      height: 100%;
      background: #fff;
    }
  }
}

.dkillCardBto {
  margin-top: 13px;
  padding-top: 20px;
  border-top: 2px solid rgba(148, 147, 147, 0.1);
  zoom: 1;
}

.dkillCardBto::after {
  display: block;
  clear: both;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  content: '';
}

.audition {
  display: flex;
  align-items: center;
  float: left;
  height: 100%;
  color: #ff6c02;
  font-size: 22px;

  img {
    width: 24px;
    height: 24px;
    margin-right: 11px;
  }
}

.endTime {
  display: flex;
  align-items: center;
  float: right;
  height: 30px;
  color: #787878;
  font-size: 24px;

  span {
    display: flex;
    align-items: center;
    height: 30px;
    color: #787878;
    font-size: 24px;
  }

  .timeNumber {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin: 0 5px;
    color: #fff;
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    background: #fe681d;
    border-radius: 4px;
  }
}
</style>
